module.exports = __webpack_public_path__ + "static/media/icon-visa-card.1167648e.svg";